import { buildDirectBuyData } from '@auth0spa/util/ECommerceUtil';
import {
    Features,
    useFeatureFlagValue,
} from '@auth0spa/util/FeatureFlagUtil';
import { Typography } from '@mui/material';
import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { DirectBuyOrderSummaryComponent } from '../../../common/UiDirectBuy';
import {
    SignupOptionsComponent,
    UiSignupContainer,
} from '../../../common/UiSignup';
import { useParams } from '../../../container/Router';

const useStyles = makeStyles(theme =>
    createStyles({
        trademark: {
            color: theme.palette.semantic.colorForeground,
            fontWeight: 400,
            fontSize: '8px',
            position: 'relative',
            top: '-0.4em',
        },
        directBuyTitle: {
            fontSize: '20px',
            fontWeight: 600,
            color: theme.palette.semantic.colorForeground,
            margin: '32px 0 22px 0',
        },
    }),
);

const DirectBuyContainer = () => {
    const classes = useStyles();
    const params = useParams();
    const { formatMessage: translate } = useIntl();
    const getTitle = () => {
        return <Typography
            align="center"
            data-cy='direct-buy-preview-title'
            className={classes.directBuyTitle}>
            {translate({ id: 'GET_STARTED_FOR_DIRECT_BUY' }, {
                tm: (chunks: string) => <sup className={classes.trademark}>
                    {chunks}
                </sup>,
            })}
        </Typography>;
    };

    const { EnableEcommerceRobotUnits } = useFeatureFlagValue([ Features.EnableEcommerceRobotUnits ]);
    const directBuyData = useMemo(() => {
        return buildDirectBuyData(EnableEcommerceRobotUnits, params);
    }, [ EnableEcommerceRobotUnits, params ]);

    return (
        <UiSignupContainer
            customTitle={getTitle()}>
            <DirectBuyOrderSummaryComponent
                directBuySku={params.direct_buy_sku}
                directBuyData={directBuyData} />
            <SignupOptionsComponent />
        </UiSignupContainer>
    );
};

export default DirectBuyContainer;
